import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteTollExtraordinaryAssignment } from '../../../../actions';

export const DeleteTollExtraordinaryAssignmentButton = ({
  tollExtraordinaryAssignmentId,
  saving,
  dispatchDeleteTollExtraordinaryAssignment,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickShowModal = () => setShowModal(true);

  const onClickCancel = () => setShowModal(false);

  const onClickDelete = () => {
    dispatchDeleteTollExtraordinaryAssignment({
      tollExtraordinaryAssignmentId,
    });
  };

  return (
    <>
      <Button color="danger" onClick={onClickShowModal} disabled={saving}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>

      <ConfirmationModal
        show={showModal}
        body="Se eliminarán todos los tipos de servicio y peajes de esta asignación. ¿Desea continuar?"
        onClickConfirm={onClickDelete}
        onClickCancel={onClickCancel}
      />
    </>
  );
};

DeleteTollExtraordinaryAssignmentButton.propTypes = {
  tollExtraordinaryAssignmentId: PropTypes.number.isRequired,
  saving: PropTypes.bool,
  dispatchDeleteTollExtraordinaryAssignment: PropTypes.func.isRequired,
};

DeleteTollExtraordinaryAssignmentButton.defaultProps = {
  saving: false,
};

const mapStateToProps = ({ RouteUnit }) => ({
  saving: !RouteUnit.TollExtraordinaryAssignment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchDeleteTollExtraordinaryAssignment: deleteTollExtraordinaryAssignment,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteTollExtraordinaryAssignmentButton);
